import { Link, useParams } from "react-router-dom";
import flyerData from "../data/flyerData.json";
import "../styles/HomeNew.css";

export default function Flyer() {
    const { name } = useParams();

    const flyer = flyerData.flyers.find(f => name.localeCompare(f.link) === 0);
    const flyerFile = flyer ? flyer.file : "YGC.jpg";
    const flyerName = flyer ? flyer.name : "Flyer";
    const source = `/images/flyers/${flyerFile}`;

    return (
        <div className="pg">

            {/* ── MINI HERO ── */}
            <section className="hero" style={{ minHeight: "22svh", paddingBlock: "3rem" }}>
                <div className="hero__glow hero__glow--1" />
                <div className="hero__glow hero__glow--2" />
                <div className="hero__inner" style={{ gridTemplateColumns: "1fr" }}>
                    <div className="hero__text">
                        <p className="hero__kicker" style={{ marginBottom: ".5rem" }}>
                            <Link to="/flyers" style={{ color: "var(--pu-200)", textDecoration: "none", fontWeight: 700 }}>
                                ← All Flyers
                            </Link>
                        </p>
                        <h1 className="hero__h1" style={{ fontSize: "clamp(1.8rem, 4vw, 3.5rem)" }}>
                            {flyerName}
                        </h1>
                    </div>
                </div>
            </section>

            {/* ── FLYER IMAGE ── */}
            <section className="local" style={{ maxWidth: "860px", marginInline: "auto" }}>
                <div className="lcard lcard--open" style={{ padding: "1.5rem", alignItems: "center" }}>
                    <img
                        src={source}
                        alt={flyerName}
                        style={{
                            width: "100%",
                            borderRadius: "12px",
                            display: "block",
                            boxShadow: "0 8px 40px rgba(0,0,0,.1)",
                        }}
                    />
                </div>
                <div style={{ marginTop: "1.25rem", display: "flex", justifyContent: "center" }}>
                    <Link to="/flyers" className="lcard__toggle" style={{ textDecoration: "none" }}>
                        ← Back to all flyers
                    </Link>
                </div>
            </section>

        </div>
    );
}